module.exports = __webpack_public_path__ + "static/img/yd-banner1.af711a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/yd-banner1.jpg
// module id = 7nK4
// module chunks = 1